import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChange,
  ViewChild,
  OnChanges,
} from "@angular/core";
import { OrderNotesGridService } from "../../../../core/services/order-notes-grid.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Table, TableModule } from "primeng/table";
import { OrderNotesSidebarService } from "../../../../core/services/order-notes-sidebar.service";
import { SalesOrderNotes } from "../../../../core/models/orders/salesOrderNotes";
import { LoaderService } from "../../../../core/services/loader.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { SharedService } from "../../../../core/services/shared.service";

@UntilDestroy()
@Component({
  selector: "jni-order-notes-grid",
  templateUrl: "./order-notes-grid.component.html",
  styleUrls: ["./order-notes-grid.component.scss"],
  imports: [
    TableModule,
    HidedynamicsdatePipe,
    CommonModule,
    FormsModule,
    SelectModule,
    ButtonModule,
  ],
})
export class OrderNotesGridComponent implements OnInit, OnChanges {
  @Input() saleOrderId = "";
  @Input() userBlockedFromEdit = false;
  @Input() orderType = "";
  @Output() selectedOrderNotesListing = new EventEmitter<SalesOrderNotes[]>();

  @ViewChild("dt") table!: Table;

  purchaseOrderNumber: string[] = [];
  orderNotesGridListing: SalesOrderNotes[] = [];
  selectedOrderNotesGridListing: SalesOrderNotes[] = [];

  typeList = [
    {
      id: 1,
      name: "Billing note",
    },
    {
      id: 2,
      name: "Collections",
    },
    // 11286 - PGL-270 Remove Invoice Note option From All Note Forms
    // {
    //   id: 3,
    //   name: 'Invoice note'
    // },
    {
      id: 4,
      name: "Order note",
    },
  ];
  @Input() showAll = false;
  displayOrderNotesGridList: SalesOrderNotes[] = [];
  bgColor = "";
  constructor(
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private _orderNotesGridService: OrderNotesGridService,
    private _orderNotesSidebarService: OrderNotesSidebarService,
    private _sharedService: SharedService
  ) {}

  ngOnInit(): void {
    if (this.saleOrderId) {
      this.getSalesOrderNotes(this.saleOrderId);
      //this.getAllLinePoNumber(this.saleOrderId); OptimzationWork 27-02-2025
    }
  }

  ngOnChanges(changes: Record<string, SimpleChange>) {
    if (this.saleOrderId && changes["showAll"]) {
      this.showAllOrderNotesOrNot();
    }
  }

  getSalesOrderNotes(saleOrderId: string) {
    this._orderNotesGridService
      .getSalesOrderNotes(saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.selectedOrderNotesGridListing = [];
          if (res.data) {
            this.orderNotesGridListing = res.data;
            if (!this.showAll) {
              this.displayOrderNotesGridList = this.orderNotesGridListing.slice(
                0,
                5
              );
            } else {
              this.displayOrderNotesGridList = this.orderNotesGridListing;
            }
          }
        },
        error: res => {
          this._toastr.error("Error", res.message || "Order note not found");
        },
      });
  }

  getAllLinePoNumber(saleOrderId: string) {
    if (saleOrderId) {
      this._orderNotesSidebarService
        .getAllLinePoNumber(saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.purchaseOrderNumber = res.data;
          },
        });
    }
  }

  onEditRow(orderNotesGridListing: SalesOrderNotes) {
    this.cancelAllEditRow();
    this.getAllLinePoNumber(this.saleOrderId);
    const row = this.table.value.filter(x => x.id === orderNotesGridListing.id);
    if (row.length > 0) {
      this.table.initRowEdit(row[0]);
    }
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  onRowEditSave(orderNotesGridListing: SalesOrderNotes) {
    this.cancelAllEditRow();
    if (!orderNotesGridListing.type) {
      this._toastr.error("Error", "Type is required");
      this.getSalesOrderNotes(this.saleOrderId);
      return;
    }
    if (!orderNotesGridListing.description) {
      this._toastr.error("Error", "Description is required");
      this.getSalesOrderNotes(this.saleOrderId);
      return;
    }

    // As per the ticket #13735 its no longer needed here as Purchase order can't be removed on edit row feature.
    // if (
    //   orderNotesGridListing?.type === "Billing note" &&
    //   !orderNotesGridListing?.purchaseOrderId
    // ) {
    //   this._toastr.error("Error", "Purchase Order is required");
    //   this.getSalesOrderNotes(this.saleOrderId);
    //   return;
    // }

    this._loaderService.setLoaderState(true);
    this._orderNotesSidebarService
      .AddSalesOrderNotes(orderNotesGridListing)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.getSalesOrderNotes(this.saleOrderId);
            this._toastr.success(
              "Success",
              res.message || "Order note update successfully"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error updating order note"
          );
        },
      });
  }

  updateSingleLine() {
    if (this.selectedOrderNotesGridListing.length === 1) {
      this.selectedOrderNotesListing.emit(this.selectedOrderNotesGridListing);
    }
  }

  deleteSaleOrderNotes() {
    const array: number[] = [];
    if (this.selectedOrderNotesGridListing.length > 0) {
      this.selectedOrderNotesGridListing.forEach(x => {
        array.push(x.id);
      });
      this._loaderService.setLoaderState(true);
      this._orderNotesSidebarService
        .deleteSalesOrderNotes(array)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.getSalesOrderNotes(this.saleOrderId);
              this.selectedOrderNotesGridListing = [];
              this._toastr.success(
                "Success",
                res.message || "Order note delete successfully"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error deleting order note"
            );
          },
        });
    }
  }

  disabledField(type: string) {
    if (type === "Billing note") {
      return false;
    } else if (type === "Order note") {
      return false;
    } else {
      return true;
    }
  }

  onPurchaseorderstatus = false;
  onPurchaseorderchange(type: string, id: number) {
    if (type === "Billing note") {
      this.onPurchaseorderstatus = false;
    } else if (type === "Order note") {
      this.onPurchaseorderstatus = false;
    } else {
      this.onPurchaseorderstatus = true;
      const lineObject = this.orderNotesGridListing?.find(x => x?.id === id);
      if (lineObject) {
        if (lineObject?.purchaseOrderId) {
          lineObject.purchaseOrderId = "";
        }
      }
    }
  }

  showAllOrderNotesOrNot() {
    if (!this.showAll) {
      this.displayOrderNotesGridList = this.orderNotesGridListing.slice(0, 5);
    } else {
      this.displayOrderNotesGridList = this.orderNotesGridListing;
    }
  }

  // Add this property to your component
  get isDarkTheme(): boolean {
    return this._sharedService.getTheme()() === "dark";
  }
}
